import { gettext } from '@eventbrite/i18n';
/**  GENERAL MESSAGES  **/
export const CREATE_ACCOUNT_MESSAGE = gettext('Create account');

/**  ACCOUNT SOCIAL CONNECTIONS MESSAGES  **/
export const ACCOUNT_CONNECTED_TO_FACEBOOK_ERROR_MESSAGE = gettext(
    'Your account is connected to Facebook.',
);
export const ACCOUNT_CONNECTED_TO_APPLE_ERROR_MESSAGE = gettext(
    'Your account is connected to Apple.',
);
export const ACCOUNT_CONNECTED_TO_GOOGLE_ERROR_MESSAGE = gettext(
    'Your account is connected to Google.',
);
export const ACCOUNT_CONNECTED_TO_APPLE_AND_FB_ERROR_MESSAGE = gettext(
    'Your account is connected to Apple and Facebook.',
);
export const ACCOUNT_CONNECTED_TO_APPLE_AND_GOOGLE_ERROR_MESSAGE = gettext(
    'Your account is connected to Apple and Google.',
);
export const ACCOUNT_CONNECTED_TO_GOOGLE_AND_FB_ERROR_MESSAGE = gettext(
    'Your account is connected to Google and Facebook.',
);
export const ACCOUNT_CONNECTED_TO_GOOGLE_APPLE_AND_FB_ERROR_MESSAGE = gettext(
    'Your account is connected to Apple, Google and Facebook.',
);
export const ACCOUNT_CONNECTED_TO_SOCIAL_ERROR_MESSAGE = gettext(
    'There is a social account associated for the provided email address.',
);

export const SOCIAL_ERROR_POPUP_BLOCKED_MESSAGE = gettext(
    'We couldn’t connect to your social account. Please disable your pop-up blocker and try again.',
);
export const SOCIAL_ERROR_UNKNOWN_MESSAGE = gettext(
    'We couldn’t connect your accounts. Be sure to disable your pop-up blocker and turn off incognito mode. Then try again, or use a different browser.',
);
export const SOCIAL_ERROR_NOT_AUTHORIZED_MESSAGE = gettext(
    'Sign in to your social account to connect it to Eventbrite.',
);
export const SOCIAL_ERROR_SERVER_MESSAGE = gettext(
    'We’re having trouble connecting. Please try again.',
);
export const STAFF_USER_NOT_ALLOWED_ERROR_MESSAGE = gettext(
    'Staff user is not allowed to login using social buttons.',
);
export const USER_ALREADY_HAS_EXTERNAL_PROVIDER_MESSAGE = gettext(
    'The user has already linked a Social account. To continue, sign in with your Eventbrite account and unlink it manually.',
);

export const LINK_ACCOUNTS_OPTION_FOR_EXTERNAL_USER_EMAIL_ML_MESSAGE = gettext(
    "This email address is already registered with an Eventbrite account. We'll send you a magic link to connect your accounts.",
);

export const EXTERNAL_USER_EMAIL_USED_ON_SOFT_ACCOUNT_ERROR_MESSAGE = gettext(
    "This email has been used in Eventbrite before. To login, you'll need to create a password for this account",
);
export const EMAIL_PERMISSION_DENIED_ERROR_MESSAGE = gettext(
    'The email address associated with your Facebook account could not be retrieved. Try again and grant access to email permissions or add an email to your Facebook account. ',
);

export const TOKEN_NOT_AUTHORIZED_ERROR_MESSAGE = gettext(
    'Unexpected error. That was weird. Try again.',
);

export const EXISTING_ACCOUNT_INFO = {
    titleText: gettext('Used Eventbrite before?'),
    buttonCTA: gettext('Link account'),
    subtitleText: gettext(
        'If you have an existing Eventbrite account, enter your email and password to see all your tickets in one place.',
    ),
    yesButtonText: gettext('Yes, I have an account'),
    noButtonText: gettext("No, I'm new here"),
};

export const ENTER_VALID_EMAIL = gettext('Please enter a valid email address');

export const UNKNOWN_EXTERNAL_PROVIDER_ERROR_MESSAGE = gettext(
    'Whoops! There was an error with your login attempt. Please try again later or choose a different login method.',
);

export const SIGNUP_EMAIL_EXISTS = gettext(
    'There is an account associated with the email.',
);

export const GENERIC_ERROR_MESSAGE =
    'There has been an error. Please try again later.';

export const TEXT_TOKEN_EXPIRES_TIME = gettext(
    'For your security, the link expires in 15 minutes',
);

export const TEXT_TOKEN_USED_ONCE = gettext(
    'Links can only be used once and expire after 2 hours.',
);
